module.exports = __webpack_public_path__ + "static/water_glacier5-f13315f3cd06ba2c7cd39cdd5f62db12.jpg";